import { FormFieldOverrideMap } from 'components/form/formTypes'
import { UnitMagnitude } from 'types'

/** Asset-model dataKey for the allowable-stress (S) input — the FFS `yield_strength` field. */
export const YIELD_STRENGTH_DATAKEY = 'yield_strength'

/** Asset-model dataKey for the coefficient-Y input — the FFS `pressure_coefficient` field. */
export const PRESSURE_COEFFICIENT_DATAKEY = 'pressure_coefficient'

/**
 * FFS-only relabels/transforms for the shared asset-model fields, keyed by
 * `dataKey`. Applied via the `fieldOverrides` seam so the shared component
 * schema (and every other workflow) is untouched:
 *  - `yield_strength` → labeled "Allowable Stress (S)". The material-stress
 *    picker writes the allowable stress S into this field, so the FFS label
 *    matches what the value actually is (SME preference). Stored key unchanged.
 *  - `radius` → shown/edited as "Diameter (Outer)" (2×radius), always in
 *    inches|mm regardless of the field's default unit family. The stored value
 *    stays a true outer radius (`fromDisplay` halves it on save), so every
 *    downstream calc that does `radius * 2 = D` is unaffected. The ×2/÷2 scalar
 *    is unit-independent, so the toggle's imperial/metric choice still applies.
 */
export const FFS_FIELD_OVERRIDES: FormFieldOverrideMap = {
  [YIELD_STRENGTH_DATAKEY]: { label: 'Allowable Stress (S)' },
  radius: {
    label: 'Diameter (Outer)',
    unit_magnitude: UnitMagnitude.InchesOrMillimeters,
    toDisplay: (radius) => radius * 2,
    fromDisplay: (diameter) => diameter / 2,
  },
}
